/** 固定長フィールド行から算出する集計 */
export interface FixedFieldTotals {
  /** 各フィールド length の合計（無効・未入力は 0） */
  lengthSum: number;
  /** 各フィールド count の合計（1 以上のみ加算、未入力は加算しない） */
  countSum: number;
}

/**
 * length 合計と count 合計を一度に算出（フォーム行が少ない前提で単純ループ）
 */
export function computeFixedFieldTotals(rows: { length?: unknown; count?: unknown }[]): FixedFieldTotals {
  return rows.reduce(
    (acc, row) => {
      const len = Number(row.length);
      if (Number.isFinite(len) && len > 0) {
        acc.lengthSum += len;
      }
      const cntRaw = row.count;
      const cntNum = cntRaw != null && cntRaw !== '' ? Number(cntRaw) : NaN;
      if (Number.isFinite(cntNum) && cntNum >= 1) {
        acc.countSum += cntNum;
      }
      return acc;
    },
    { lengthSum: 0, countSum: 0 },
  );
}

/**
 * 各フィールド length の合計（無効・未入力は 0 とみなす）
 */
export function sumFixedEntityFieldLengths(rows: { length?: unknown }[]): number {
  return computeFixedFieldTotals(rows).lengthSum;
}
